import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  padding-top: 60px;
  min-height: 80vh;
  background-color: #fbfbfb;
  margin-top: -7px;
`;

const InfoWrapper = styled.div`
  margin-top: 30px;
`;

const Error = ({ heading, ...props }) => {
  let defaultHeading = "Sorry, something went wrong. We are looking into it.";
  return (
    <Wrapper>
      <div className="container">
        {/* <h3>
          We could not find any matching topics for your search term: "
          {keyword}"
        </h3> */}
        <h3>{heading ? heading : defaultHeading}</h3>
        <InfoWrapper>
          <p>Please check your spelling</p>
          <p>Try alternative spellings</p>
          <p>Try any name variations</p>
          <p>Try related terms</p>

          <br />
          <br />
          <br />
          <br />
        </InfoWrapper>
      </div>
    </Wrapper>
  );
};

export default Error;
